module.exports = __webpack_public_path__ + "img/gold3.1ff551f2.png";